<template>

  <div>
    <p class="desc-info">
      <span>订单号：{{ flowInfo.orderId }}</span>
      <span>任务类型：机翻</span>
      <span>当前任务状态：{{ this.$flowStatus.get(flowInfo.status) }}</span>
      <span>语种方向：{{ $sysLan.get(slan) }}-{{ $sysLan.get(tlan) }}</span>
      <el-button type="primary" icon="el-icon-document" size="mini" class="m-r-10" @click="toOrderDetail" plain>订单详情</el-button>
    </p>
    <el-tabs type="card">
      <el-tab-pane label="机翻任务译稿">
        <el-row>
          <el-col offset="1">
            <el-radio-group v-model="tranFromat">
              <el-radio label="1">纯译文</el-radio>
              <el-radio label="2">段段对照</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <fileDown v-if="(flowInfo.orderId&&slan)" :taskType="1" :type="2" :tranFromat="tranFromat" :orderId="flowInfo.orderId" :staParams="staParams" key="end"/>
      </el-tab-pane>
      <el-tab-pane label="机翻平行语料稿">
        <fileDown v-if="flowInfo.orderId" :taskType="1" :type="3" :orderId="flowInfo.orderId" :staParams="staParams" key="eq"/>
      </el-tab-pane>
      <el-tab-pane label="机翻进度">
        <div>
          <el-row :span="24">
            <el-col span="5" offset="1">订单总稿件个数: {{jlInfo.fileNum}}</el-col>
            <el-col span="5">总聚类个数: {{jlInfo.groupNum}}</el-col>
            <el-col span="5">已完成机翻的聚类个数: {{jlInfo.mtFinishNum}}</el-col>
          </el-row>
        </div>
        <!-- <fileDown :type="1" @head="headFunction" :orderId="flowInfo.orderId" :staParams="staParams" key="eq"/> -->
      </el-tab-pane>
    </el-tabs>

    <el-dialog :close-on-click-modal="false" title="创建打标任务" :visible.sync="markingDialogVisible">
      <el-form :model="markingForm">
        <el-form-item label="" label-width="20px">
          <el-radio v-model="markingForm.type" label="1">只需一次打标<br>（相同包仅打一次标，适用于对结果要求不高的项目）</el-radio>
          <br><br>
          <el-radio v-model="markingForm.type" label="2">一次打标+抽样二次打标<br>（相同包抽样后由信用度交稿的译员进行二次打标，适用于对结果要求较高的项目）</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="markingDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitCreateMarking">确定创建</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" title="创建PE任务" :visible.sync="peDialogVisible">
      <el-form :model="peForm">
        <el-form-item label="" label-width="20px">
          <p>请选择PE标准</p>
          <el-radio v-model="peForm.type" label="3" disabled>PE+快审（快速交付，审核比例较低）</el-radio>
          <br>
          <el-radio v-model="peForm.type" label="4">PE+标审（标准审核，大多数项目的选择）</el-radio>
          <br>
          <el-radio v-model="peForm.type" label="5">PE+全审（全部审核，适用于对质量要求较高的项目）</el-radio>
        </el-form-item>
        <el-form-item label="" label-width="20px">
          <p>是否需要质控<span style="color:#F56C6C" v-if="isNeedQc">（您的项目较大，质控环节为必选）</span></p>
          <el-radio v-model="peForm.needQc" :disabled="isNeedQc" label="2">是</el-radio>
          <el-radio v-model="peForm.needQc" :disabled="isNeedQc" label="1">否</el-radio>
          <p>质控是在PE过程中介入，帮助把控项目总体质量的角色</p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="peDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitCreatePe">确定创建</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>


import {getFlowInfo, getFlowList, addMarkingFlow, addPeFlow} from '@/api/dot/flow'
import {countWords,getObj, tjInfo} from '@/api/dot/order'
import {statistics} from '@/api/dot/flow'
import fileDown from '@/views/common/fileDown'
import {alertErroMsg, alertSuccessMsg} from "@/util/commonMsg";
import {mapState} from "vuex";

export default {
  components: {fileDown},
  data() {
    return {
      tranFromat:'1',
      markingDialogVisible: false,
      markingForm: {
        type: "1"
      },
      head:{},
      loading: false,
      isNeedQc: false,
      peDialogVisible: false,
      peForm: {
        type: "4",
        needQc: "2"
      },
      slan:"",
      tlan:"",
      page: false,
      endData: [],
      flowInfo: {},
      eqData: [],
      showCreateMarking: false,
      showCreatePe: false,
      staParams: null,
      jlInfo: {}, 
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    }),
  },
  created: function () {
    this.flowInfo = {}
    getFlowInfo(this.$route.params.id).then(response => {
      this.flowInfo = response.data.data
      getObj(this.flowInfo.orderId).then(res=>{
        this.slan = res.data.data.slan;
        this.tlan = res.data.data.tlan;
        this.tranFromat = res.data.data.tranFormat + ""
      })
      tjInfo(this.flowInfo.orderId).then(res=>{
        console.log(res.data)
        this.jlInfo = res.data.data;
      })
    })

  },
  beforeRouteEnter(to, from, next) {
    next(vm=>{
      vm.curPath = to.path;
      vm.oldPath = from.path;
    })
	},
  mounted() {
    this.staParams = {
      u_id: this.userInfo.staffId,
      time: new Date().getTime(),
      browser: navigator.userAgent.toLowerCase(),
      url: this.curPath,
      ref_url: this.oldPath,
      scene_name: '机翻任务详情'
    }
    this.statistics()
    
  },
  methods: {
    statistics() {
      statistics(Object.assign({
        event_type: 'view'
      }, this.staParams))
    },

    toOrderDetail() {
      this.$router.push({path:'/dot/order/detail/'+this.flowInfo.orderId});
      statistics(Object.assign({
        event_name: '订单详情',
        event_type: 'click',
      }, this.staParams))
    },

    headFunction(val) {
      this.head = val;
    },

    // 获取聚类信息
    getJlInfo() {
      console.log(this.flowInfo.orderId);
      
    },

    preCheckPeDialogVisible() {
      countWords(this.flowInfo.orderId).then(res => {
        this.isNeedQc = parseFloat(res.data.data.wordCount) > 50000;
      })
      this.peDialogVisible = true
    },
    submitCreateMarking() {
      this.loading = true
      addMarkingFlow({
        flowId: this.$route.params.id,
        orderId: this.flowInfo.orderId,
        type: this.markingForm.type
      }).then(res => {
        this.markingDialogVisible = false
        if (res.data.data === 1) {
          alertSuccessMsg();
        } else if (res.data.data === 2) {
          this.$alert(`添加成功，请前往配置打标任务`, {
            confirmButtonText: '确定',
            callback: action => {
              if (action === 'confirm') {
                this.$router.replace('/refresh')
                setTimeout(() => {
                  this.$router.push({path: '/dot/flow/detail-marking/' + res.data.msg})
                }, 500)
              } else {
                this.$router.replace('/refresh')
              }
            },
          });
        } else {
          alertErroMsg();
        }
        statistics(Object.assign({
          event_type: 'click',
          event_name: '创建打标任务',
          class_name: 'addMarkingFlow',
          class_url: '/dotadmin/dotadmin/flow/addMarkingFlow',
          event_params: '{flowId: this.$route.params.id, orderId: this.flowInfo.orderId, type: this.markingForm.type}'
        }, this.staParams))
      })
    },

    submitCreatePe() {
      this.loading = true
      addPeFlow({
        flowId: this.$route.params.id,
        orderId: this.flowInfo.orderId,
        type: this.peForm.type,
        needQc: this.peForm.needQc
      }).then(res => {
        this.peDialogVisible = false
        if (res.data.data === 1) {
          alertSuccessMsg();
        } else if (res.data.data === 2) {
          this.$alert(`添加成功，请前往配置PE任务`, {
            confirmButtonText: '确定',
            callback: action => {
              if (action === 'confirm') {
                this.$router.replace('/refresh')
                setTimeout(() => {
                  this.$router.push({path: '/dot/flow/detail-pe/' + res.data.msg})
                }, 500)
              } else {
                this.$router.replace('/refresh')
              }
            },
          });
        } else {
          alertErroMsg();
        }
        statistics(Object.assign({
          event_type: 'click',
          event_name: '创建PE任务',
          class_name: 'addPeFlow',
          class_url: '/dotadmin/dotadmin/flow/addPeFlow',
          event_params: 'flowId: this.$route.params.id, orderId: this.flowInfo.orderId, type: this.peForm.type, needQc: this.peForm.needQc}'
        }, this.staParams))
      })

    },


  },
  filters: {},
}

</script>
<style lang="scss" scoped>
.avue-view {
  background: #FFFFFF;
  padding: 20px;
  min-height: calc(100vh - 100px);
}

.desc-info {
  width: 100%;
  padding-left: 0;

  > span {
    margin-right: 50px;
  }
}

</style>
